import React from 'react';

const DocumentWarningIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      style={{
        height: props.height ? `${props.height}px` : '',
        width: props.height ? `${props.height * 0.75}px` : ''
      }}
      viewBox="0 0 18 24"
    >
      <path fill="#FF6060" d="M1 0v23h16.5V7l-7-7H1Z"/>
      <path fill="#804040" fillRule="evenodd" d="M17.498 7.073 10.988.5a1.802 1.802 0 0 0-.446-.323c-.016-.01-.034-.017-.05-.024l-.015-.007A1.677 1.677 0 0 0 9.797 0H1.71C.778 0 0 .755 0 1.688v20.625C0 23.244.778 24 1.71 24h14.602c.933 0 1.665-.755 1.665-1.688V8.262c0-.446-.165-.872-.479-1.189ZM10 1l7 7h-6a1 1 0 0 1-1-1V1Zm6 22a1 1 0 0 0 1-1V8.8h-6.138C9.84 8.8 8.987 7.995 8.987 7V1H2a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h14Z" clipRule="evenodd"/>
      <path fill="#804040" fillRule="evenodd" d="M12.75 15.15v2.734L14 18.978v.547h-3.757c-.069.547-.601.975-1.243.975-.647 0-1.175-.428-1.243-.975H4v-.547l1.25-1.094V15.15c0-1.684 1.019-3.085 2.813-3.457v-.372c0-.454.418-.82.937-.82.519 0 .938.367.938.82v.372c1.787.372 2.812 1.778 2.812 3.457Z" clipRule="evenodd"/>
    </svg>
  );
};

DocumentWarningIcon.defaultProps = { height: 24 };
export default DocumentWarningIcon;
